import React, { useEffect, useState } from 'react';
import { ClockIcon, SparklesIcon } from 'lucide-react';
type OfferItemsProps = {
  time: string;
  spots: number;
  duplicate?: boolean;
};
function OfferItems({
  time,
  spots,
  duplicate = false
}: OfferItemsProps) {
  return <div className="flex shrink-0 items-center gap-4 pr-10" data-id="element-328" data-mp="2nglj8n8mdg9c">
      <span className="inline-flex items-center gap-1.5 text-brand-goldLight" data-id="element-329" data-mp="2sagb4dydp1ji"><ClockIcon className="h-4 w-4" data-id="element-330" data-mp="2wb8kd77936fs" />Oferta de lanzamiento termina en</span>
      <span className="rounded-md bg-white/10 px-2 py-1 font-mono font-bold tracking-wider tabular-nums" data-id="element-331" data-mp="2wdcmbjll9vdf">{time}</span>
      <span className="h-4 w-px bg-white/25" aria-hidden="true" data-id="element-332" data-mp="369fqev004430" />
      <span className="inline-flex items-center gap-1.5" data-id="element-333" data-mp="367398k22hxr0"><SparklesIcon className="h-4 w-4 text-brand-gold" data-id="element-334" data-mp="3b8ivgffzeaaz" /><strong className="text-brand-gold" data-id="element-335" data-mp="3b66eo5lym5zi">{spots}%</strong> de cupos reservados</span>
      {duplicate ? <span className="rounded-md bg-brand-gold px-3 py-1 text-xs font-bold text-brand-ink" data-id="element-336" data-mp="1bx8240i6qlg7">Ver oferta</span> : <a href="#pricing" className="rounded-md bg-brand-gold px-3 py-1 text-xs font-bold text-brand-ink transition-colors hover:bg-brand-goldLight" data-id="element-337" data-mp="1gw2thqu7xibx">Ver oferta</a>}
    </div>;
}
export function UrgencyBanner() {
  const [time, setTime] = useState({
    h: 0,
    m: 59,
    s: 51
  });
  const [spots, setSpots] = useState(72);
  useEffect(() => {
    const countdown = window.setInterval(() => {
      setTime(current => {
        if (current.h === 0 && current.m === 0 && current.s === 0) return current;
        if (current.s > 0) return {
          ...current,
          s: current.s - 1
        };
        if (current.m > 0) return {
          h: current.h,
          m: current.m - 1,
          s: 59
        };
        return {
          h: current.h - 1,
          m: 59,
          s: 59
        };
      });
    }, 1000);
    const spotsTimer = window.setInterval(() => setSpots(value => Math.min(value + (Math.random() > .55 ? 1 : 0), 89)), 45000);
    return () => {
      window.clearInterval(countdown);
      window.clearInterval(spotsTimer);
    };
  }, []);
  const format = (value: number) => String(value).padStart(2, '0');
  const formattedTime = `${format(time.h)}:${format(time.m)}:${format(time.s)}`;
  return <aside className="sticky top-0 z-50 border-b border-brand-gold/50 bg-brand-ink text-white shadow-lg" aria-label="Oferta de lanzamiento" data-id="element-338" data-mp="shvqeqvcx5y0">
      <div className="urgency-marquee" data-id="element-339" data-mp="xf5eo370fbk9">
        <div className="urgency-marquee-track flex w-max items-center whitespace-nowrap py-2.5 text-xs font-semibold sm:text-sm" data-id="element-340" data-mp="jpbpfjrlepa0">
          <OfferItems time={formattedTime} spots={spots} data-id="element-341" data-mp="oga6wmobhteu" />
          <div aria-hidden="true" data-id="element-342" data-mp="ohv4ym9ubuhg"><OfferItems time={formattedTime} spots={spots} duplicate data-id="element-343" data-mp="9re00sxzymft" /></div>
        </div>
      </div>
    </aside>;
}